async function googleTranslate(text, targetLang) {
  if (!text) return '';
  try {
    const url = `https://translate.googleapis.com/translate_a/single?client=gtx&sl=ja&tl=${targetLang}&dt=t&q=${encodeURIComponent(text)}`;
    const res = await fetch(url);
    const data = await res.json();
    return data[0].map(item => item[0]).join('');
  } catch { return ''; }
}

export async function translateAll(nameJa, descJa, isStandard) {
  if (!nameJa) return {};

  if (isStandard) {
    const [nameEn, nameZhCN, nameZhTW, nameKo,
           descEn, descZhCN, descZhTW, descKo] = await Promise.all([
      googleTranslate(nameJa, 'en'),
      googleTranslate(nameJa, 'zh-CN'),
      googleTranslate(nameJa, 'zh-TW'),
      googleTranslate(nameJa, 'ko'),
      googleTranslate(descJa, 'en'),
      googleTranslate(descJa, 'zh-CN'),
      googleTranslate(descJa, 'zh-TW'),
      googleTranslate(descJa, 'ko'),
    ]);
    return { nameEn, nameZhCN, nameZhTW, nameKo,
             descEn, descZhCN, descZhTW, descKo };
  } else {
    const [nameEn, descEn] = await Promise.all([
      googleTranslate(nameJa, 'en'),
      googleTranslate(descJa, 'en'),
    ]);
    return { nameEn, descEn };
  }
}
